import React from 'react';
import styles from './css/index.module.scss';
import Button from '../../../../ui-kit/Button';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';
import useInputState from '../../../../hooks/useInputState';
import Input from '../../../../ui-kit/Input';

function NewProjectModal({ onSave }) {
  const { t } = useTranslations();
  const [name, setName, nameError, setNameError] = useInputState('');

  const onSaveClick = () => {
    const trimmedName = name.trim();
    if (trimmedName.length < 2) {
      setNameError(t(DICTIONARY.minimum2symbols));
      return;
    }

    onSave(trimmedName);
  };

  return (
    <div className={styles.newProjectModal}>
      <p className={styles.title}>{t(DICTIONARY.newProject)}</p>
      <div className={styles.field}>
        {nameError ? <p className={styles.error}>{nameError}</p> : null}
        <Input
          value={name}
          onChange={setName}
          placeholder={t(DICTIONARY.projectName)}
          width="100%"
          error={nameError ? 'NO_ERROR_TEXT' : undefined}
        />
      </div>
      <div className={styles.buttons}>
        <Button width="100%" text={t(DICTIONARY.add)} onClick={onSaveClick} />
      </div>
    </div>
  );
}

export default NewProjectModal;
